// useBookingQuestions.js — perguntas do agendamento manual. O AppointmentFormDialog só entrega { vm, actions } ao bloco do CD
// e pede as respostas na hora de enviar.
import { useCallback, useMemo, useState } from 'react';
import { useBookingCustomFields, usePersonCustomFields } from '../../hooks/queries/useCustomFields';
import { buildBookingQuestionsVm, fieldErrorsFrom, prefillFromPerson, toAnswers } from './customFieldsVmBuilder';

const LOAD_ERROR = 'Não foi possível carregar as perguntas. Você pode agendar assim mesmo.';

export function useBookingQuestions({ professionalId, placeId, serviceId, personId }) {
  const { fields, loading, error, reload } = useBookingCustomFields({ professionalId, placeId, serviceId });
  const person = usePersonCustomFields(personId);
  const [edited, setEdited] = useState({});
  const [errors, setErrors] = useState({});

  const values = useMemo(() => ({ ...prefillFromPerson(fields, person.data?.values), ...edited }), [fields, person.data, edited]);

  const vm = useMemo(
    () => buildBookingQuestionsVm({ loading, errorMessage: error ? LOAD_ERROR : null, fields, values, errors }),
    [loading, error, fields, values, errors],
  );

  const actions = {
    onFieldChange: (fieldId, value) => {
      setEdited((current) => ({ ...current, [fieldId]: value }));
      setErrors((current) => ({ ...current, [fieldId]: null }));
    },
    onRetry: () => reload(),
  };

  // Trocar de serviço troca as perguntas: só vai o que vale para as atuais.
  const answers = () => toAnswers(Object.fromEntries(fields.map((field) => [field.id, values[field.id]])), fields);

  const showErrors = (submitError) => {
    const fieldErrors = fieldErrorsFrom(submitError);
    if (fieldErrors) setErrors(fieldErrors);
  };

  const reset = useCallback(() => {
    setEdited({});
    setErrors({});
  }, []);

  return { vm, actions, answers, showErrors, reset };
}
